export default __webpack_public_path__ + "static/media/tailwind-logo.e41b95a8.svg";